// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1RO4s","head":"Table_head__3G5Tf","col":"Table_col__6y9Qu"};